<template>
  <v-page page="Dashboards" :breadcrumb="breadcrumb">
    <v-container ma-0 px-4 pt-3 pb-0>
      <bar-chart-container :DBID="DBID" :isMounted="isMounted"></bar-chart-container>
    </v-container>
  </v-page>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import BarChartContainer from "../../components/Dashboards/BarChartContainer.vue";
import "@/assets/css/main.css"

export default {
  name: "DashboardView",
  components: { VPage, BarChartContainer },

  data: () => ({
    DBID: null,
    isMounted: false
  }),
  computed: {
    breadcrumb() {
      var breadcrumb = [
        {
          text: "Dashboards",
          disabled: false,
          href: "#/dashboards"
        },
        {
          text: "D"+this.DBID,
          disabled: true,
          href: "#/dashboard-view/" + this.DBID
        }
      ];
      return breadcrumb;
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.DBID = await this.$route.params.DBID;
      this.isMounted = true;
    }
  }
};
</script>
<style scoped>
</style>